export const WS_BASE_URL = "https://virtual-property.in/api/routes.php";
export const BASE_URL = "https://virtual-property.in";
export const BASE_IMG_URL = "https://virtual-property.in";
export const DRAWER_WIDTH = 250;
export const ADMIN_SESSION_NAME = "admin-data";
export const USER_SESSION_NAME = "user-data";
export const ExcelHeaders = [
    ["1000000", "__EMPTY", "__EMPTY_1"],
    ["2000000", "__EMPTY_2", "__EMPTY_3"],
    ["3000000", "__EMPTY_4", "__EMPTY_5"],
    ["4000000", "__EMPTY_6", "__EMPTY_7"],
    ["5000000", "__EMPTY_8", "__EMPTY_9"],
    ["6000000", "__EMPTY_10", "__EMPTY_11"],
    ["7000000", "__EMPTY_12", "__EMPTY_13"],
    ["8000000", "__EMPTY_14", "__EMPTY_15"],
    ["9000000", "__EMPTY_16", "__EMPTY_17"],
    ["10000000", "__EMPTY_18", "__EMPTY_19"],
    ["11000000", "__EMPTY_20", "__EMPTY_21"],
    ["12000000", "__EMPTY_22", "__EMPTY_23"],
    ["13000000", "__EMPTY_24", "__EMPTY_25"],
    ["14000000", "__EMPTY_26", "__EMPTY_27"],
    ["15000000", "__EMPTY_28", "__EMPTY_29"],
    ["16000000", "__EMPTY_30", "__EMPTY_31"],
    ["17000000", "__EMPTY_32", "__EMPTY_33"],
    ["18000000", "__EMPTY_34", "__EMPTY_35"],
    ["19000000", "__EMPTY_36", "__EMPTY_37"],
    ["20000000", "__EMPTY_38", "__EMPTY_39"]
];